<template>
  <div>
    <h2>{{ $localize('RegistrationEmailValidationErrorTitle') }}</h2>
    <p class="lead">
      {{ $localize('RegistrationEmailValidationErrorText') }}
    </p>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">

</style>